var map = {
	"./angel-1.png": 3197,
	"./angel-10.png": 6665,
	"./angel-11.png": 416,
	"./angel-12.png": 8059,
	"./angel-13.png": 6930,
	"./angel-14.png": 4829,
	"./angel-15.png": 8148,
	"./angel-16.png": 2639,
	"./angel-17.png": 3622,
	"./angel-2.png": 1574,
	"./angel-3.png": 1551,
	"./angel-4.png": 224,
	"./angel-5.png": 1401,
	"./angel-6.png": 690,
	"./angel-7.png": 8555,
	"./angel-8.png": 748,
	"./angel-9.png": 9845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2689;